import { useQuery } from '@tanstack/react-query';
import { User } from 'src/models/user/_types';
import { fetchUsers } from 'src/models/user/user';
import { getUserDisplayName } from 'src/models/user/utils';
import { BaseSelectOption } from 'src/shared/Forms/Selects/BaseSelect';
import { TrainerSelect } from 'src/shared/Forms/Selects/TrainerSelect';
import { Identifier } from 'src/types/utilityTypes';

interface TrainerFilterConfig {
  field: string;
  label: string;
  value: string | undefined;
  setValue: (newVal: string | undefined) => void;
  valueOnly?: boolean;
  multiple?: boolean;
  filterOptions?: (
    options: BaseSelectOption[],
    { inputValue }: { inputValue: string }
  ) => BaseSelectOption[];
}

export const TrainerFilter: React.FC<TrainerFilterConfig> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple,
  filterOptions,
}) => {
  const trainerIds = value ? String(value).split(',') : [];

  const { data: users = [] } = useQuery<User[]>({
    queryKey: ['users', trainerIds],
    queryFn: () => fetchUsers({ ids: trainerIds as Identifier[] }),
    enabled: !!value && valueOnly,
  });

  if (valueOnly) {
    if (multiple && value) {
      return (
        <>
          {users
            ?.filter((u) => trainerIds.includes(String(u.id)))
            .map((u) => getUserDisplayName(u))
            .join(', ')}
        </>
      );
    }
    return <>{users?.map((u) => getUserDisplayName(u)).join(', ') || ''}</>;
  }

  return (
    <TrainerSelect
      label={label}
      value={
        multiple ? users?.map((u) => u.id || '') || [] : users?.[0]?.id || ''
      }
      valueOnly={false}
      onChange={(newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((s) => s.id).join(',')
          );
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      placeholder="Any"
      multiple={multiple}
      filterOptions={filterOptions}
    />
  );
};
